import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';

function norm(x){
  x=x||{};
  return Object.freeze({
    symbol:x.symbol||null,
    scope:['OWNED','WATCHLIST','RESEARCH'].includes(x.scope)?x.scope:'RESEARCH',
    readiness:['READY_FOR_DECISION','REVIEW','BLOCKED'].includes(x.readiness)?x.readiness:'REVIEW',
    priority:['CRITICAL','HIGH','MEDIUM','REVIEW','LOW','NONE'].includes(x.priority)?x.priority:'NONE',
    whatChanged:x.whatChanged||null,
    why:x.why||null,
    transmission:x.transmission||null,
    next:x.next||null,
    verification:['VERIFIED','PARTIAL','UNVERIFIED'].includes(x.verification)?x.verification:'UNVERIFIED'
  });
}
function sentence(v,fallback){return typeof v==='string'&&v.trim()?v.trim():fallback}
function briefItem(input){
  const x=norm(input);
  return Object.freeze({
    symbol:x.symbol,
    scope:x.scope,
    state:x.readiness,
    lines:Object.freeze([
      sentence(x.whatChanged,'No material change established.'),
      sentence(x.why,'Cause not yet established.'),
      sentence(x.transmission,'No company-specific transmission established.'),
      sentence(x.next,'No immediate research action.')
    ]),
    verification:x.verification,
    tradeSignal:false,
    capitalPermission:false
  });
}
function portfolioBrief(items,maxItems){
  const rows=Array.isArray(items)?items:[];
  const score={CRITICAL:6,HIGH:5,MEDIUM:4,REVIEW:3,LOW:2,NONE:1};
  const state={BLOCKED:3,REVIEW:2,READY_FOR_DECISION:1};
  const sorted=rows.slice().sort((a,b)=>{
    const na=norm(a), nb=norm(b);
    const owned=(nb.scope==='OWNED'?1:0)-(na.scope==='OWNED'?1:0);
    if(owned!==0) return owned;
    const s=state[nb.readiness]-state[na.readiness];
    if(s!==0) return s;
    return score[nb.priority]-score[na.priority];
  });
  const n=Number.isFinite(maxItems)?Math.max(1,Math.floor(maxItems)):4;
  return Object.freeze({
    top:Object.freeze(sorted.slice(0,n).map(briefItem)),
    hiddenCount:Math.max(0,sorted.length-n),
    tradeSignal:false
  });
}
function headline(input){
  const x=norm(input);
  if(x.readiness==='BLOCKED') return `${x.symbol||'Company'}: blocked — resolve evidence or decision-path issue first.`;
  if(x.readiness==='REVIEW') return `${x.symbol||'Company'}: review required before decision.`;
  return `${x.symbol||'Company'}: research path is complete enough for human decision.`;
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const a={symbol:'AAA',scope:'OWNED',readiness:'BLOCKED',priority:'CRITICAL',whatChanged:'Rates worsened.',why:'Policy repricing.',transmission:'Financing cost pressure.',next:'Verify refinancing schedule.',verification:'VERIFIED'};
  const b={symbol:'BBB',scope:'WATCHLIST',readiness:'REVIEW',priority:'HIGH',verification:'PARTIAL'};
  const c=briefItem(a);
  ok('brief contains four compressed lines',c.lines.length===4);
  ok('brief carries readiness state',c.state==='BLOCKED');
  ok('brief remains non-trading',c.tradeSignal===false);
  ok('brief grants no capital permission',c.capitalPermission===false);
  ok('missing text receives safe fallback',briefItem(b).lines.every(x=>typeof x==='string'&&x.length>0));
  const p=portfolioBrief([b,a],4);
  ok('owned blocked item ranks first',p.top[0].symbol==='AAA');
  ok('portfolio brief remains non-trading',p.tradeSignal===false);
  ok('portfolio brief hidden count correct',p.hiddenCount===0);
  ok('blocked headline is explicit',headline(a).includes('blocked'));
  ok('review headline is explicit',headline(b).includes('review'));
  ok('ready headline avoids buy language',!headline({...a,readiness:'READY_FOR_DECISION'}).toLowerCase().includes('buy'));
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,norm,briefItem,portfolioBrief,headline,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestExecutiveBriefEngine=Object.freeze(API);
})(engineContext);
